<div class="card-header">
  <app-breadcrumb currentPage="Factuuroverzicht"></app-breadcrumb>
</div>

<div class="card-body">
  <mat-paginator [length]="totalElements"
                 [pageSize]="pageSize"
                 [pageSizeOptions]="pageSizeOptions"
                 (page)="pageEvent = updatePage($event)">
  </mat-paginator>

  <table matSort (matSortChange)="sortPage($event)" class="table full-width">
    <thead>
    <tr>
      <th mat-sort-header="client.firstUser.name.firstName">bewindvoerder</th>
      <th mat-sort-header="client.name.firstName">belanghebbende</th>
      <th mat-sort-header="year,invoiceNumber">factuurnummer</th>
      <th mat-sort-header="payedAt">betaald op</th>
      <th mat-sort-header="Type">type</th>
      <th mat-sort-header="status">status</th>
      <th mat-sort-header="amount">bedrag</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of content" class="pointer" (click)="download(row)">
        <td>{{row.user}}</td>
        <td>{{row.client}}</td>
        <td>{{row.invoiceNumber}}</td>
        <td>{{row.payedAt}}</td>
        <td>{{row.type.toLowerCase()}}</td>
        <td>{{row.status?.toLocaleLowerCase()}}</td>
        <td>
          <app-discount-price
            [amount]="row.amount / 100"
            [discount]="row.discount">
          </app-discount-price>
        </td>
      </tr>
    </tbody>
  </table>
</div>










